export const getOwnerNameByData = ({owner_first_name, owner_last_name, owner_email}) => {
    const owner_name = [owner_first_name, owner_last_name];

    return owner_name.join('') ? owner_name.join(' ') : owner_email;
};
